import { isSetEqual } from '@attain-apps/data-utils'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'

/**
 * Effect that groups conversations by agentId using the groupPlugin. Creates a
 * group for each unique agentId found in the current list of conversations.
 */
export const putAgentGroups = store.effects.create(
  (feature: Collection['feature'], collection: Collection) =>
    collection.plugins.currentListPlugin.feature.selectors.entities.asObservable.pipe(
      rxjs.map(
        conversations =>
          new Set(
            conversations
              .map(conversation => conversation.agentId)
              .filter(TypeChecker.isNotNullish.raw),
          ),
      ),
      rxjs.distinctUntilChanged((a, b) => isSetEqual(a, b)),
      rxjs.map(agentIds =>
        collection.plugins.groupPlugin.feature.actions.put
          .from('putAgentGroups (effect)')
          .create({
            groups: [...agentIds].map(agentId => ({
              entitySelector: {
                predicate: conversation => conversation.agentId === agentId,
              },
              id: agentId,
              name: agentId,
            })),
          }),
      ),
    ),
)
